import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export function ProspectAuthProvider({ children }) {
  const [user, setUser]   = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('prospect_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUser({ id: payload.userId, email: payload.email, name: payload.name, role: payload.role, tenant_id: payload.tenantId });
      } catch {
        localStorage.removeItem('prospect_token');
        setToken(null);
      }
    }
    setLoading(false);
  }, [token]);

  async function login(email, password) {
    const { data } = await axios.post('/prospect/auth/login', { email, password });
    localStorage.setItem('prospect_token', data.token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    setToken(data.token);
    const payload = JSON.parse(atob(data.token.split('.')[1]));
    setUser({ id: payload.userId, email: payload.email, name: payload.name, role: payload.role, tenant_id: payload.tenantId });
    return payload;
  }

  function logout() {
    localStorage.removeItem('prospect_token');
    delete axios.defaults.headers.common['Authorization'];
    setToken(null);
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useProspectAuth() {
  return useContext(AuthContext);
}
